import { render, staticRenderFns } from "./DeletableCard.vue?vue&type=template&id=5ca53645&scoped=true&"
import script from "./DeletableCard.vue?vue&type=script&lang=js&"
export * from "./DeletableCard.vue?vue&type=script&lang=js&"
import style0 from "./DeletableCard.vue?vue&type=style&index=0&id=5ca53645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca53645",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
